module.exports = __webpack_public_path__ + "img/agenda-screen.webp";